

























































import { Button } from "ant-design-vue";
import Vue from "vue";

export default Vue.extend({
  name: "Index",
  data() {
    return {
      email: ""
    };
  },
  components: {
    [Button.name]: Button,
    [Button.Group.name]: Button.Group
  },
  methods: {
    navToKyc() {
      window.sessionStorage.setItem("partnerAccountEmail", this.email);
      const role = "broker";
      this.$router.push({
        name: "kyc",
        params: { lang: this.$i18n.locale },
        query: { role }
      });
    }
  },
  created() {
    // setup locale to "zh" when user navigate to partner first time.
    // Changing $i18n.locale inside a component does not update the root locale.
    this.$root.$i18n.locale = "zh";
  }
});
